import React, { Component } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtBtn from "../Components/CustomTool/CtBtn";
import CtTxt from "../Components/CustomTool/CtTxt";
import CtCmb from "../Components/CustomTool/CtCmb";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowOfRT,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import CtART from "./CustomTool/ResponsiveTable";
import { fetchRaiseOfLift } from "./API";

class RaiseOfLift extends Component {
  state = {
    statusOptions: ["Active", "Inactive"],
    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "SR No",
        size: 10,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_raiseoflift",
        header: "Name",
      },
      {
        accessorKey: "int_status",
        header: "Status",
      },
    ],

    rows: [
      {
        bint_srno: 1,
        vac_raiseoflift: "Raise Of Lift 1",
        int_status: "Active",
      },
    ],
    formData: {
      bint_srno: 0,
      txtRaiseOfLiftName: "",
      cmbStatus: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    localStorage.setItem("Heading", "Raise Of Lift");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
    this.ShortCut();
  }

  componentWillUnmount() {
    this.removeShortCut();
  }

  //#endregion Component

  //#region Handle

  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      this.saveRaiseOfLift,
      this.clearInfo,
      () => {
        this.DeleteData(
          this.state.formData.bint_srno,
          this.state.formData.txtRaiseOfLiftName,
        );
      },
    );
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_srno",
      "vac_raiseoflift",
      "int_status",
    ]);
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno: row.bint_srno,
        txtRaiseOfLiftName: row.vac_raiseoflift,
        cmbStatus: row.int_status == 1 ? "Active" : "Inactive",
      },
    });
    document.getElementById("txtRaiseOfLiftName").focus();
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_raiseoflift"]);
    this.DeleteData(row.bint_srno, row.vac_raiseoflift);
  };

  //#endregion Handle

  //#region function

  getInfo = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ListRaiseOfLift",
    };
    fetchRaiseOfLift(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        let rows = res.data.RaiseOfLiftList,
          rowsCount = rows.length;

        this.setState({
          rowsCount,
          rows,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    document.getElementById("txtRaiseOfLiftName").focus();
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno: 0,
          txtRaiseOfLiftName: "",
          cmbStatus: "",
        },
      },
      () => {
        document.getElementById("txtRaiseOfLiftName").focus();
      },
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validationRaiseOfLift = () => {
    let result = false;
    if (this.state.formData.txtRaiseOfLiftName.length <= 0) {
      this.props.toastErrorMsg("Enter Name", "txtRaiseOfLiftName");
    } else if (this.state.formData.cmbStatus.length <= 0) {
      this.props.toastErrorMsg("Select Status", "cmbStatus");
    } else {
      result = true;
    }
    return result;
  };

  saveRaiseOfLift = () => {
    this.trimFormData(() => {
      if (this.validationRaiseOfLift()) {
        this.props.notifyProcessing();
        const reqData = {
          Op: "SaveRaiseOfLift",
          bint_srno: this.state.formData.bint_srno,
          vac_raiseoflift: this.state.formData.txtRaiseOfLiftName,
          int_status: this.state.formData.cmbStatus == "Active" ? 1 : 0,
        };
        fetchRaiseOfLift(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let rows = [],
                rowsCount = rows.length;
              if (
                res.data.RaiseOfLiftList &&
                res.data.RaiseOfLiftList.length > 0
              ) {
                rows = res.data.RaiseOfLiftList;
                rowsCount = rows.length;
              }
              this.setState(
                {
                  rows,
                  rowsCount,
                },
                () => {
                  this.clearInfo();
                },
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in Save Raise Of Lift.", error);
          });
      }
    });
  };

  DeleteData = (bint_srno, vac_raiseoflift) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete : ${vac_raiseoflift} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteRaiseOfLift(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteRaiseOfLift = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteRaiseOfLift",
      bint_srno: bint_srno,
    };
    fetchRaiseOfLift(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.RaiseOfLiftList && res.data.RaiseOfLiftList.length > 0) {
            rows = res.data.RaiseOfLiftList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.clearInfo();
            },
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Raise Of Lift. " + error,
        );
      });
    return false;
  };

  //#endregion function

  render() {
    return (
      <form>
        <Grid container direction="row" justifyContent="flex-end">
          <Grid item>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <CtBtn
                  className="secondary-button"
                  label="Save"
                  iconName="save"
                  onClick={this.saveRaiseOfLift}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  className="new-button"
                  iconName="new"
                  onClick={this.clearInfo}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  className="delete-button"
                  iconName="delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txtRaiseOfLiftName,
                    );
                  }}
                  disabled={this.state.formData.bint_srno > 0 ? false : true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container direction="row" spacing={2} marginTop={0}>
          <Grid item>
            <CtTxt
              id="txtRaiseOfLiftName"
              label="Name*"
              value={this.state.formData.txtRaiseOfLiftName}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"cmbStatus"}
            />
          </Grid>
          <Grid item>
            <CtCmb
              id="cmbStatus"
              label="Status*"
              items={this.state.statusOptions}
              value={this.state.formData.cmbStatus}
              handleOnChange={this.handleOnChange}
              width={220}
              onKeyDown={this.props.onKeyDown}
              defaultAction={this.saveRaiseOfLift}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={1}
        >
          <Grid item className="maintable">
            <CtART
              rowsdata={this.state.rows}
              columnsdata={this.state.columnsdata}
              rowsPerPage={this.state.rowsPerPage}
              tblmaxHeight={500}
              csvFileName={csvFileName("Raise Of Lift")}
              rowIconAction={[
                {
                  label: "Edit",
                  onClick: this.handleARDonActionClick_Edit,
                  icon: "Edit",
                  className: "secondary-button",
                },
                {
                  label: "Delete",
                  onClick: this.handleARDonActionClick_Delete,
                  icon: "delete",
                  className: "delete-button",
                },
              ]}
              showColumnFilters={false}
              actionColSize={40}
              density={"compact"}
              hideColIdList={[""]}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <RaiseOfLift {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
